import { useReactiveVar } from '@apollo/client';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { isLoggedInVar } from '../apollo';

import Home from '../pages/home';
import Footer from '../pages/layout/footer';
import Header from '../pages/layout/header';
import Login from '../pages/member/login';
import Signup from '../pages/member/signup';
import playapiInDocs from '../pages/guide/swagger/playapiInDocs';
import EmpDocs from '../pages/guide/swagger/empdocs';
import PartnershipDocs from '../pages/guide/swagger/partnershipdocs';
import playapiOutDocs from '../pages/guide/swagger/playapiOutDocs';
import NotFound from '../pages/notfound';
import empapiDocs from '../pages/guide/swagger/empapiDocs';
import empInternalApiDocs from '../pages/guide/swagger/empInternalApiDocs';

import ShopList from '../pages/admin/shopList';
import ShopListUpdate from '../pages/admin/shopListUpdate';
import MyPage from '../pages/member/mypage';
import PlayApiIntro from '../pages/playapiintro/playapiintro';
import PlayApiExample from '../pages/playapiintro/playapiexample';
import IntroMethod from '../pages/playapiintro/intromethod';
import PlayApiGuide from '../pages/guide/playapiguide';
import JobSearch from '../pages/admin/jobSearch';
import AddJob from '../pages/guide/addjob';
//hash router google.com/#hello
//switch -> 오직 한 route만 import 할 수 있게 해주는 장치

//scroll 항상 탑으로 이동시키기 위해 필요함
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

export function ReactRouter() {
    //Client Cache에 Local State 요청
    const isLoggedIn = useReactiveVar(isLoggedInVar);

    // 헤더,푸터 제외 할 path  여기에 추가
    const onlyBody = [
        '/guide/empapiDocs',
        '/guide/empDocs',
        '/guide/partnerShipDocs',
        '/guide/playApiInDocs',
        '/guide/empInternalApiDocs',
        '/admin/shop-list',
        '/admin/shop-list-update',
        '/admin/job-search',
    ];

    // 헤더,푸터 제외
    return onlyBody.includes(window.location.pathname) ? (
        <Router>
            <Switch>
                <Route path="/guide/empapiDocs" component={empapiDocs} />
                <Route path="/guide/empDocs" component={EmpDocs} />
                <Route path="/guide/partnerShipDocs" component={PartnershipDocs} />
                <Route path="/guide/empInternalApiDocs" component={empInternalApiDocs} />
                {/* 쇼핑몰리스트 */}
                <Route path="/admin/shop-list" component={ShopList} />
                <Route path="/admin/shop-list-update" component={ShopListUpdate} />
                {/* playapi 내부 제공용 */}
                <Route path="/guide/playApiInDocs" component={playapiInDocs} />
                {/* 작업 조회 */}
                <Route path="/admin/job-search" component={JobSearch} />
            </Switch>
        </Router>
    ) : (
        // 헤더,푸터 포함
        //리엑트는 원래 URL 입력시 에러난다.(LINK로 라우터 연결이 아니고 직접입력시), 따라서 AWS S3 웹이미지 호스팅 오류문서에 index.html 똑같이 적어줘야함
        <Router>
            <ScrollToTop />
            <Header />
            <div className="content">
                <Switch>
                    <Route path="/member/mypage" component={MyPage} />

                    {/* exact는 path값이 완전히 일치할때만 해당 컴포넌트를 노출한다. */}
                    <Route exact path="/" component={Home} />
                    <Route path="/member/login" component={Login} />

                    {/* 개발완료 후 옮기기 */}

                    {/* api소개 */}
                    <Route path="/info/playApiIntro" component={PlayApiIntro} />
                    <Route path="/info/playApiExample" component={PlayApiExample} />
                    <Route path="/info/IntroMethod" component={IntroMethod} />
                    {/* 개발가이드 & api 문서 */}
                    <Route path="/guide/playApiGuide" component={PlayApiGuide} />

                    {isLoggedIn && (
                        <>
                            {/* playapi 외부 제공용 */}
                            <Route path="/guide/playapiOutDocs" component={playapiOutDocs} />

                            <Route path="/guide/addJob" component={AddJob} />

                            {/* 나의정보 */}
                            <Route path="/member/mypage" component={MyPage} />
                        </>
                    )}

                    {/* {!isLoggedIn && <Route path="/Login" component={Login} />} */}
                    <Route path="*" component={NotFound} />
                </Switch>
            </div>
            <Footer />
        </Router>
    );
}
